import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api';
import { useAuthStore } from '../auth';
import { AuthShell } from '../components/AuthShell';

export function LoginPage() {
  const navigate = useNavigate();
  const setTokens = useAuthStore((s) => s.setTokens);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const tokens = await api.login({ email, password });
      setTokens(tokens);
      navigate('/');
    } catch (e) {
      setErr(
        e instanceof ApiError
          ? humanizeAuthError(e.message)
          : 'Network error',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell title="Sign in to ScoreLync">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="label">Email</label>
          <input
            className="input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="label">Password</label>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {err && (
          <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
            {err}
          </div>
        )}
        <button className="btn btn-primary w-full" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in →'}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-muted">
        No account?{' '}
        <Link to="/signup" className="text-brand-light hover:text-brand">
          Create an organization
        </Link>
      </p>
    </AuthShell>
  );
}

function humanizeAuthError(code: string): string {
  switch (code) {
    case 'invalid_credentials':
      return 'Email or password is incorrect.';
    case 'org_suspended':
      return 'Your organization has been suspended. Contact support.';
    default:
      return code;
  }
}
